var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindowsVentMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.0048828,13H30.0106201v2h10.9942627c1.6542969,0,3,1.3457031,3,3v6.0255737 C43.166626,23.3909912,42.1348267,23,41.0048828,23H17.0107422c-4.6240234,0-5.8574219,2.4667969-7.9003906,6.5517578L6.3817749,35 h-1.758728c-0.3408203,0-0.6181641-0.2773438-0.6181641-0.6181641c0-0.0957031,0.0224609-0.1914062,0.0654297-0.2763672 l6.8291016-13.6582031C12.8808594,16.4833984,13.6230469,15,17.0107422,15H24v-2h-6.9892578 c-4.6240234,0-5.8574219,2.4667969-7.9003906,6.5527344L2.28125,33.2109375 c-0.1806641,0.3613281-0.2763672,0.7666016-0.2763672,1.1708984C2.0048828,35.8251953,3.1796875,37,4.6230469,37H24v-2H8.6196899 l2.2797241-4.5527344C12.8808594,26.4833984,13.6230469,25,17.0107422,25h23.9941406c1.6542969,0,3,1.3457031,3,3v4 c0,1.6542969-1.3457031,3-3,3H30.0106201v2h10.9942627c2.7568359,0,5-2.2431641,5-5v-4V18 C46.0048828,15.2431641,43.7617188,13,41.0048828,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0042114,43.5817261L28,29h-2l0.0042114,14.5901489l-3.2971802-3.2971802l-1.4140625,1.4140625l5,5 C26.4882812,46.9023438,26.7441406,47,27,47s0.5117188-0.0976562,0.7070312-0.2929688l5-5l-1.4140625-1.4140625 L28.0042114,43.5817261z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0042114,4.4098511L26,19h2l0.0042114-14.5817261l3.2887573,3.2887573l1.4140625-1.4140625l-5-5 c-0.390625-0.390625-1.0234375-0.390625-1.4140625,0l-5,5l1.4140625,1.4140625L26.0042114,4.4098511z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsVentMedium);
export default __webpack_public_path__ + "static/media/windows-vent--medium.b3241f7360bcd022e64392ce31901599.svg";
export { ForwardRef as ReactComponent };